import { call, put, all, takeLatest } from "redux-saga/effects";

import {
  INVOICE_DRAFT_LIST_REQUEST,
  INVOICE_DRAFT_SEARCH_REQUEST,
  INVOICE_DRAFT_CREATE_REQUEST,
  INVOICE_DRAFT_UPDATE_REQUEST,
  INVOICE_DRAFT_VOID_REQUEST,
  INVOICE_DRAFT_PDF_REQUEST,
  INVOICE_DRAFT_DAILY_BALANCE_REQUEST,
  INVOICE_DRAFT_STATUS_LIST_REQUEST,
  INVOICE_DRAFT_STATUS_DATA_REQUEST,
  INVOICE_DRAFT_STATUS_CREATE_REQUEST,
  INVOICE_DRAFT_STATUS_UPDATE_REQUEST,
  INVOICE_DRAFT_STATUS_DELETE_REQUEST,
  INVOICE_DRAFT_DATA_REQUEST,
  INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_REQUEST,
  INVOICE_DRAFT_CONVERT_TO_INVOICE_REQUEST,
} from "./actionType";

import {
  invoiceDraftListSuccess,
  invoiceDraftListFailure,
  invoiceDraftSearchSuccess,
  invoiceDraftSearchFailure,
  invoiceDraftCreateSuccess,
  invoiceDraftCreateFailure,
  invoiceDraftUpdateSuccess,
  invoiceDraftUpdateFailure,
  invoiceDraftVoidSuccess,
  invoiceDraftVoidFailure,
  invoiceDraftPdfSuccess,
  invoiceDraftPdfFailure,
  invoiceDraftDailyBalanceSuccess,
  invoiceDraftDailyBalanceFailure,
  invoiceDraftStatusListSuccess,
  invoiceDraftStatusListFailure,
  invoiceDraftStatusDataSuccess,
  invoiceDraftStatusDataFailure,
  invoiceDraftStatusCreateSuccess,
  invoiceDraftStatusCreateFailure,
  invoiceDraftStatusUpdateSuccess,
  invoiceDraftStatusUpdateFailure,
  invoiceDraftStatusDeleteSuccess,
  invoiceDraftStatusDeleteFailure,
  invoiceDraftDataSuccess,
  invoiceDraftDataFailure,
  invoiceDraftActivityLogSearchSuccess,
  invoiceDraftActivityLogSearchFailure,
  invoiceDraftConvertToInvoiceSuccess,
  invoiceDraftConvertToInvoiceFailure,
} from "./action";

import {
  getInvoiceDraftList,
  searchInvoiceDraft,
  createInvoiceDraft,
  updateInvoiceDraft,
  voidInvoiceDraft,
  getInvoiceDraftPdf,
  getInvoiceDraftDailyBalance,
  getInvoiceDraftStatusList,
  getInvoiceDraftStatusData,
  createInvoiceDraftStatus,
  updateInvoiceDraftStatus,
  deleteInvoiceDraftStatus,
  getInvoiceDraftData,
  searchInvoiceDraftActivityLog,
  convertToInvoice,
} from "../../helpers/fakebackend_helper";

//INVOICE_DRAFT_LIST_REQUEST
function* invoiceDraftListSaga() {
  try {
    const response = yield call(getInvoiceDraftList);
    yield put(invoiceDraftListSuccess(response));
  } catch (error) {
    yield put(invoiceDraftListFailure(error));
  }
}
//watcher saga for INVOICE_DRAFT_LIST_REQUEST
export function* watchInvoiceDraftListSaga() {
  yield takeLatest(INVOICE_DRAFT_LIST_REQUEST, invoiceDraftListSaga);
}
//INVOICE_DRAFT_SEARCH_REQUEST
function* invoiceDraftSearchSaga(action) {
  try {
    const response = yield call(searchInvoiceDraft, action.payload);
    yield put(invoiceDraftSearchSuccess(response));
  } catch (error) {
    yield put(invoiceDraftSearchFailure(error));
  }
}
//watcher saga for INVOICE_DRAFT_SEARCH_REQUEST
export function* watchInvoiceDraftSearchSaga() {
  yield takeLatest(INVOICE_DRAFT_SEARCH_REQUEST, invoiceDraftSearchSaga);
}
//INVOICE_DRAFT_CREATE_REQUEST
function* invoiceDraftCreateSaga(action) {
  try {
    const response = yield call(createInvoiceDraft, action.payload);
    yield put(invoiceDraftCreateSuccess(response));
  } catch (error) {
    yield put(invoiceDraftCreateFailure(error));
  }
}
//watcher saga for INVOICE_DRAFT_CREATE_REQUEST
export function* watchInvoiceDraftCreateSaga() {
  yield takeLatest(INVOICE_DRAFT_CREATE_REQUEST, invoiceDraftCreateSaga);
}
//INVOICE_DRAFT_UPDATE_REQUEST
function* invoiceDraftUpdateSaga(action) {
  try {
    const response = yield call(updateInvoiceDraft, action.payload);
    yield put(invoiceDraftUpdateSuccess(response));
  } catch (error) {
    yield put(invoiceDraftUpdateFailure(error));
  }
}
//watcher saga for INVOICE_DRAFT_UPDATE_REQUEST
export function* watchInvoiceDraftUpdateSaga() {
  yield takeLatest(INVOICE_DRAFT_UPDATE_REQUEST, invoiceDraftUpdateSaga);
}
//INVOICE_DRAFT_VOID_REQUEST
function* invoiceDraftVoidSaga(action) {
  try {
    const response = yield call(voidInvoiceDraft, action.payload);
    yield put(invoiceDraftVoidSuccess(response));
  } catch (error) {
    yield put(invoiceDraftVoidFailure(error));
  }
}
//watcher saga for INVOICE_DRAFT_VOID_REQUEST
export function* watchInvoiceDraftVoidSaga() {
  yield takeLatest(INVOICE_DRAFT_VOID_REQUEST, invoiceDraftVoidSaga);
}
//INVOICE_DRAFT_PDF_REQUEST
function* invoiceDraftPdfSaga(action) {
  try {
    const response = yield call(getInvoiceDraftPdf, action.payload);
    yield put(invoiceDraftPdfSuccess(response));
  } catch (error) {
    yield put(invoiceDraftPdfFailure(error));
  }
}
//watcher saga for INVOICE_DRAFT_PDF_REQUEST
export function* watchInvoiceDraftPdfSaga() {
  yield takeLatest(INVOICE_DRAFT_PDF_REQUEST, invoiceDraftPdfSaga);
}
//INVOICE_DRAFT_DAILY_BALANCE_REQUEST
function* invoiceDraftDailyBalanceSaga(action) {
  try {
    const response = yield call(getInvoiceDraftDailyBalance, action.payload);
    yield put(invoiceDraftDailyBalanceSuccess(response));
  } catch (error) {
    yield put(invoiceDraftDailyBalanceFailure(error));
  }
}
//watcher saga for INVOICE_DRAFT_DAILY_BALANCE_REQUEST
export function* watchInvoiceDraftDailyBalanceSaga() {
  yield takeLatest(
    INVOICE_DRAFT_DAILY_BALANCE_REQUEST,
    invoiceDraftDailyBalanceSaga
  );
}
//INVOICE_DRAFT_STATUS_LIST_REQUEST
function* invoiceDraftStatusListSaga() {
  try {
    const response = yield call(getInvoiceDraftStatusList);
    yield put(invoiceDraftStatusListSuccess(response));
  } catch (error) {
    yield put(invoiceDraftStatusListFailure(error));
  }
}
//watcher saga for INVOICE_DRAFT_STATUS_LIST_REQUEST
export function* watchInvoiceDraftStatusListSaga() {
  yield takeLatest(
    INVOICE_DRAFT_STATUS_LIST_REQUEST,
    invoiceDraftStatusListSaga
  );
}
//INVOICE_DRAFT_STATUS_DATA_REQUEST
function* invoiceDraftStatusDataSaga(action) {
  try {
    const response = yield call(getInvoiceDraftStatusData, action.payload);
    yield put(invoiceDraftStatusDataSuccess(response));
  } catch (error) {
    yield put(invoiceDraftStatusDataFailure(error));
  }
}
//watcher saga for INVOICE_DRAFT_STATUS_DATA_REQUEST
export function* watchInvoiceDraftStatusDataSaga() {
  yield takeLatest(
    INVOICE_DRAFT_STATUS_DATA_REQUEST,
    invoiceDraftStatusDataSaga
  );
}
//INVOICE_DRAFT_STATUS_CREATE_REQUEST
function* invoiceDraftStatusCreateSaga(action) {
  try {
    const response = yield call(createInvoiceDraftStatus, action.payload);
    yield put(invoiceDraftStatusCreateSuccess(response));
  } catch (error) {
    yield put(invoiceDraftStatusCreateFailure(error));
  }
}
//watcher saga for INVOICE_DRAFT_STATUS_CREATE_REQUEST
export function* watchInvoiceDraftStatusCreateSaga() {
  yield takeLatest(
    INVOICE_DRAFT_STATUS_CREATE_REQUEST,
    invoiceDraftStatusCreateSaga
  );
}
//INVOICE_DRAFT_STATUS_UPDATE_REQUEST
function* invoiceDraftStatusUpdateSaga(action) {
  try {
    const response = yield call(updateInvoiceDraftStatus, action.payload);
    yield put(invoiceDraftStatusUpdateSuccess(response));
  } catch (error) {
    yield put(invoiceDraftStatusUpdateFailure(error));
  }
}
//watcher saga for INVOICE_DRAFT_STATUS_UPDATE_REQUEST
export function* watchInvoiceDraftStatusUpdateSaga() {
  yield takeLatest(
    INVOICE_DRAFT_STATUS_UPDATE_REQUEST,
    invoiceDraftStatusUpdateSaga
  );
}
//INVOICE_DRAFT_STATUS_DELETE_REQUEST
function* invoiceDraftStatusDeleteSaga(action) {
  try {
    const response = yield call(deleteInvoiceDraftStatus, action.payload);
    yield put(invoiceDraftStatusDeleteSuccess(response));
  } catch (error) {
    yield put(invoiceDraftStatusDeleteFailure(error));
  }
}
//watcher saga for INVOICE_DRAFT_STATUS_DELETE_REQUEST
export function* watchInvoiceDraftStatusDeleteSaga() {
  yield takeLatest(
    INVOICE_DRAFT_STATUS_DELETE_REQUEST,
    invoiceDraftStatusDeleteSaga
  );
}
//INVOICE_DRAFT_DATA_REQUEST
function* invoiceDraftDataSaga(action) {
  try {
    const response = yield call(getInvoiceDraftData, action.payload);
    yield put(invoiceDraftDataSuccess(response));
  } catch (error) {
    yield put(invoiceDraftDataFailure(error));
  }
}
//watcher saga for INVOICE_DRAFT_DATA_REQUEST
export function* watchInvoiceDraftDataSaga() {
  yield takeLatest(INVOICE_DRAFT_DATA_REQUEST, invoiceDraftDataSaga);
}

//INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_REQUEST
function* invoiceDraftActivityLogSearchSaga(action) {
  try {
    const response = yield call(searchInvoiceDraftActivityLog, action.payload);
    yield put(invoiceDraftActivityLogSearchSuccess(response));
  } catch (error) {
    yield put(invoiceDraftActivityLogSearchFailure(error));
  }
}
//watcher saga for INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_REQUEST
export function* watchInvoiceDraftActivityLogSearchSaga() {
  yield takeLatest(
    INVOICE_DRAFT_ACTIVITY_LOG_SEARCH_REQUEST,
    invoiceDraftActivityLogSearchSaga
  );
}
//INVOICE_DRAFT_CONVERT_TO_INVOICE_REQUEST
function* invoiceDraftConvertToInvoiceSaga(action) {
  try {
    const response = yield call(convertToInvoice, action.payload);
    yield put(invoiceDraftConvertToInvoiceSuccess(response));
  } catch (error) {
    yield put(invoiceDraftConvertToInvoiceFailure(error));
  }
}
//watcher saga for INVOICE_DRAFT_CONVERT_TO_INVOICE_REQUEST
export function* watchInvoiceDraftConvertToInvoiceSaga() {
  yield takeLatest(
    INVOICE_DRAFT_CONVERT_TO_INVOICE_REQUEST,
    invoiceDraftConvertToInvoiceSaga
  );
}

// Root saga to combine all watcher sagas
export default function* invoiceDraftSaga() {
  yield all([
    watchInvoiceDraftListSaga(),
    watchInvoiceDraftSearchSaga(),
    watchInvoiceDraftCreateSaga(),
    watchInvoiceDraftUpdateSaga(),
    watchInvoiceDraftVoidSaga(),
    watchInvoiceDraftPdfSaga(),
    watchInvoiceDraftDailyBalanceSaga(),
    watchInvoiceDraftStatusListSaga(),
    watchInvoiceDraftStatusDataSaga(),
    watchInvoiceDraftStatusCreateSaga(),
    watchInvoiceDraftStatusUpdateSaga(),
    watchInvoiceDraftStatusDeleteSaga(),
    watchInvoiceDraftDataSaga(),
    watchInvoiceDraftActivityLogSearchSaga(),
    watchInvoiceDraftConvertToInvoiceSaga(),
  ]);
}
